/** Ошибка обращения к сервису: статус и разобранный текст причины. */
export class ApiError extends Error {
  readonly status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

/** Достаём человеческую причину из тела ответа, если сервер её прислал. */
export async function reasonOf(res: Response): Promise<string> {
  try {
    const body: unknown = await res.json();
    if (body && typeof body === 'object') {
      const b = body as Record<string, unknown>;
      const r = b.error ?? b.message ?? b.detail;
      if (typeof r === 'string' && r) {
        // CRM при отказе правил этапа присылает ещё и список «чего не хватает» — добавляем его к причине.
        const more = Array.isArray(b.failed)
          ? (b.failed as Array<{ message?: unknown }>).map((f) => (typeof f?.message === 'string' ? f.message : '')).filter(Boolean)
          : [];
        return more.length ? `${r}: ${more.join('; ')}` : r;
      }
    }
  } catch { /* тела нет или это не JSON */ }
  return `Сервер ответил кодом ${res.status}`;
}

/** fetch с потолком ожидания: зависший запрос не должен вешать экран. */
export async function fetchWithTimeout(
  url: string,
  init: RequestInit = {},
  ms = 20_000,
): Promise<Response> {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), ms);
  try {
    return await fetch(url, { ...init, signal: ctl.signal });
  } finally {
    clearTimeout(timer);
  }
}
